import React from 'react';
import PropTypes from 'prop-types';
import ProductPicture from '@/kenwood/components/atoms/ProductPicture';

// import components
import ComparePopupContentShowDifferences from '@/kenwood/components/molecules/ComparePopupContentShowDifferences';
import OmnibusPricing from '@/components/molecules/OmnibusPricing';

const ComparePopupContentProducts = ({
  products,
  showDifferences,
  viewLabel,
  buyLabel,
  seeDifferencesLabel,
  onPopProduct,
  onToggleShowDifferences,
}) => {
  const handleRemoveProduct = ({ code, materialGroup }) => {
    onPopProduct({ productCode: code, materialGroup });
  };

  return (
    <section className='ken-compare__popup__content__products'>
      {products.length === 2 && <section className='--product' />}
      {products.map(product => {
        const productUrl = `${DLG.config.encodedContextPath}/${product.url}`;

        const mainPriceData = product.baseOptions?.[0]?.selected?.priceData;
        const oldPriceData = product.baseOptions?.[0]?.selected?.oldPriceData;
        const lastLowerPriceData = product.lastLowerPrice?.priceData;

        return (
          <section key={product.code} className='--product --fill'>
            <button
              type='button'
              className='ken-icon ken-icon--close --product-close-cta'
              onClick={() => handleRemoveProduct(product)}
            />
            <section className='--product-image'>
              <ProductPicture product={product} imgFormat='compare' />
            </section>
            <section className='--product-info'>
              <span className='--product-name'>{product.name}</span>
              <span className='--product-code'>{product.code}</span>
              <OmnibusPricing
                omnibusScenario={product.omnibusScenario}
                mainPriceValue={mainPriceData?.value}
                mainPriceFormattedValue={mainPriceData?.formattedValue}
                oldPriceValue={oldPriceData?.value}
                oldPriceFormattedValue={oldPriceData?.formattedValue}
                lastLowerPriceValue={lastLowerPriceData?.value}
                lastLowerPriceFormattedValue={
                  lastLowerPriceData?.formattedValue
                }
              />
            </section>
            <a href={productUrl} className='ken-button--link --product-link'>
              {viewLabel}
            </a>
            <a
              href={productUrl}
              className='ken-button--primary--small --product-cta'
            >
              {buyLabel}
            </a>
          </section>
        );
      })}
      <ComparePopupContentShowDifferences
        showDifferences={showDifferences}
        seeDifferencesLabel={seeDifferencesLabel}
        onToggleShowDifferences={onToggleShowDifferences}
      />
    </section>
  );
};

ComparePopupContentProducts.propTypes = {
  products: PropTypes.arrayOf(PropTypes.shape()),
  showDifferences: PropTypes.bool,
  viewLabel: PropTypes.string.isRequired,
  buyLabel: PropTypes.string.isRequired,
  seeDifferencesLabel: PropTypes.string.isRequired,
  onPopProduct: PropTypes.func,
  onToggleShowDifferences: PropTypes.func,
};

ComparePopupContentProducts.defaultProps = {
  products: [],
  showDifferences: false,
  onPopProduct: null,
  onToggleShowDifferences: null,
};

export default ComparePopupContentProducts;
